import { Component, OnInit, Input } from '@angular/core';
import { ReportBase } from '../report.base';
import { ReportsService } from '../../../../services';
import { ActivatedRoute } from '@angular/router';
import { DiscountReport, Store, AppState } from '../../../../store';

@Component({
  selector: 'app-discount-report',
  templateUrl: './discount-report.component.html',
  styleUrls: ['./discount-report.component.css']
})
export class DiscountReportComponent extends ReportBase implements OnInit {

  report: DiscountReport;
  controls = [
    { name: 'name', type: 'text', title: 'Name' },
    { name: 'discountUsedDate', type: 'date', title: 'Date' },
    { name: 'teamGroup', type: 'text', title: 'Team' },
    { name: 'gender', type: 'select', title: 'Gender', options: [ { text: 'Male', value: 'm' }, { text: 'Female', value: 'f' } ] },
    { name: 'discountCode', type: 'text', title: 'CODE' },
    { name: 'REASON', type: 'text', title: 'reason' },
    { name: 'discountAmount', type: 'number', title: 'AMOUNT' }
  ];

  constructor(
    public service: ReportsService,
    public store: Store<AppState>
  ) {
    super(service, store);
  }

  ngOnInit() {
    this.pullData('getDiscountReportData');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/components/discount-report/discount-report.component.ts